(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('IVRTime', ['HelperService', IVRTimeFn]);

    // ivr time object
    function IVRTimeFn(HelperService) {
        var IVRTime = function (weekday) {

            // object needed
            this.weekday = weekday;
            this.timeFrom = null;
            this.timeTo = null;

        };

        return IVRTime;

    }
})();